export const noop = (): void => {}

export const call = <T extends (...args: any[]) => any>(fn: T) => (
  ...e: Parameters<T>
): ReturnType<T> => fn(...e)

export const callWithoutParams = <T extends () => any>(
  fn: T,
) => (): ReturnType<T> => fn()

export const returns = <T>(x: T) => (): T => x

export const modifyParams = <T extends (...args: any[]) => any>(
  fn: T,
  modifier: (arg: any) => any,
  params: any[],
): ReturnType<T> => fn(...params.map(modifier))

export const spread = <T extends any[], R>(fn: (...args: T) => R) => (
  e: T,
): R => fn(...e)

export const packArgs = <T extends any[], R>(fn: (args: T) => R) => (
  ...e: T
): R => fn(e)

export const propNotEq = <T extends object, K extends keyof T>(
  propName: K,
  value: T[K],
) => (obj: T): boolean => obj[propName] !== value

export const returnIfMinus1 = (newVal: number, check: number): number =>
  check === -1 ? newVal : check

export const debounce = <T extends (...args: any[]) => void>(
  fn: T,
  ms: number,
): ((...args: Parameters<T>) => void) => {
  let timeoutId: ReturnType<typeof setTimeout>
  return function (this: ThisParameterType<T>, ...args: Parameters<T>) {
    clearTimeout(timeoutId)
    timeoutId = setTimeout(() => fn.apply(this, args), ms)
  }
}
